import { Typography } from '@material-ui/core';

export const ChartSrOnlySummary = (props: { summary: string; id?: string }) => {
  const { summary, id } = props;

  return (
    <Typography component="p" variant="srOnly" id={id}>
      {summary}
    </Typography>
  );
};
